// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.coingecko.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Boolean
import kotlin.Int
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.coingecko.dto.CoinDetailDto
import kpt.core.network.coingecko.dto.CoinMarketDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "coingecko")
public class _CoinGeckoApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : CoinGeckoApi {
  override suspend fun getMarkets(
    vsCurrency: String,
    order: String,
    perPage: Int,
    page: Int,
  ): List<CoinMarketDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "api/v3/coins/markets")
        vsCurrency?.let{ parameter("vs_currency", "$it") }
        order?.let{ parameter("order", "$it") }
        perPage?.let{ parameter("per_page", "$it") }
        page?.let{ parameter("page", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<CoinMarketDto>>(),)!! 
  }

  override suspend fun getCoinDetail(
    id: String,
    localization: Boolean,
    tickers: Boolean,
    communityData: Boolean,
    developerData: Boolean,
  ): CoinDetailDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "api/v3/coins/${"$id".encodeURLPath()}")
        localization?.let{ parameter("localization", "$it") }
        tickers?.let{ parameter("tickers", "$it") }
        communityData?.let{ parameter("community_data", "$it") }
        developerData?.let{ parameter("developer_data", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CoinDetailDto>(),)!! 
  }
}

public class _CoinGeckoApiProvider : ClassProvider<CoinGeckoApi> {
  override fun create(_ktorfit: Ktorfit): CoinGeckoApi = _CoinGeckoApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createCoinGeckoApi(): CoinGeckoApi = _CoinGeckoApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
